import { v4 as uuidV4 } from 'uuid'
import { Event } from '../Event'

export class EmptyEvent extends Event {
    constructor() {
        super(uuidV4(), '', null, null, 0, '', null, '', '', '')
    }
}
